const Partners = () =>
  import(/* webpackChunkName 'Partners' */ "@/components/Partners/Partners.vue");

export default {
  path: "partners",
  name: "partners",
  meta: {
    label: "Partners",
  },
  component: Partners,
};
